import { render, staticRenderFns } from "./SectionRow.vue?vue&type=template&id=1dc35754&scoped=true&"
import script from "./SectionRow.vue?vue&type=script&lang=ts&"
export * from "./SectionRow.vue?vue&type=script&lang=ts&"
import style0 from "./SectionRow.vue?vue&type=style&index=0&id=1dc35754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc35754",
  null
  
)

export default component.exports